import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkResetToken, wachtwoordReset } from '../api/authApi';

export const WachtwoordResetPage: React.FC = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token') || '';

  const [checking, setChecking] = useState(true);
  const [geldig, setGeldig] = useState(false);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setChecking(false); setGeldig(false); return; }
    checkResetToken(token).then(setGeldig).catch(() => setGeldig(false)).finally(() => setChecking(false));
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('Kies een wachtwoord van minimaal 8 tekens'); return; }
    if (pw !== pw2) { setError('De wachtwoorden komen niet overeen'); return; }
    setBusy(true);
    try {
      await wachtwoordReset(token, pw);
      setOk(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Opnieuw instellen mislukt');
    } finally { setBusy(false); }
  };

  const shell = (inner: React.ReactNode) => (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo-mijnfactuurverzekerd.svg" alt="MijnFactuurVerzekerd" className="h-16 w-auto mx-auto mb-4" />
          <p className="text-mfb-blue font-sans text-sm uppercase tracking-widest">Backoffice</p>
        </div>
        <div className="bg-white rounded-xl shadow-lg border border-slate-200 p-8">{inner}</div>
      </div>
    </div>
  );

  if (checking) return shell(<p className="text-center text-slate-500">Laden…</p>);

  if (!geldig) return shell(
    <div className="text-center">
      <h2 className="font-display text-2xl font-semibold text-mfb-blue mb-3">Link ongeldig</h2>
      <p className="text-sm text-slate-600">Deze reset-link is niet (meer) geldig. Vraag op de inlogpagina een nieuwe aan.</p>
      <button onClick={() => navigate('/login')} className="mt-5 text-sm text-mfb-orange font-medium hover:underline">Naar inloggen</button>
    </div>
  );

  if (ok) return shell(
    <div className="text-center">
      <h2 className="font-display text-2xl font-semibold text-mfb-blue mb-3">Wachtwoord ingesteld</h2>
      <p className="text-sm text-slate-600">Je kunt nu inloggen met je nieuwe wachtwoord.</p>
      <button onClick={() => navigate('/login')}
        className="mt-5 w-full py-2.5 px-4 bg-mfb-orange hover:bg-mfb-orange-dark text-white font-semibold rounded-lg transition">
        Naar inloggen
      </button>
    </div>
  );

  return shell(
    <>
      <h2 className="font-display text-2xl font-semibold text-mfb-blue mb-6 text-center">Nieuw wachtwoord</h2>
      {error && (
        <div className="mb-6 p-4 bg-mfb-orange/10 border border-mfb-orange/30 rounded-lg">
          <p className="text-sm text-mfb-orange-dark">{error}</p>
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Nieuw wachtwoord</label>
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-mfb-blue focus:border-transparent outline-none transition" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Wachtwoord herhalen</label>
          <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-mfb-blue focus:border-transparent outline-none transition" />
        </div>
        <button type="submit" disabled={busy}
          className="w-full py-2.5 px-4 bg-mfb-orange hover:bg-mfb-orange-dark disabled:bg-slate-400 text-white font-semibold rounded-lg transition shadow-sm">
          {busy ? 'Bezig…' : 'Wachtwoord instellen'}
        </button>
      </form>
    </>
  );
};

export default WachtwoordResetPage;
